import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core'

import { Material } from '@models/material'
import { urls } from '@constants/urls'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-audio-preview',
  templateUrl: './audio-preview.component.html',
  imports: [TranslatePipe]
})
export class AudioPreviewComponent implements OnInit, OnChanges {
  @ViewChild('audioElement', { static: true }) audioPlayerRef: ElementRef
  @Input() material: Material
  materialUrl: string

  ngOnInit(): void {
    this.materialUrl = `${urls.backendUrl}/download/${this.material.filekey}`
  }

  ngOnChanges(_changes: SimpleChanges): void {
    // refreshes audio player after source change
    this.audioPlayerRef.nativeElement.load()

    this.materialUrl = `${urls.backendUrl}/download/${this.material.filekey}`
  }
}
